export const metaData = {
    "title": "Help Centre | Search Results | ",
    "description": "Search Results",
    "author": "",
    "noFollow": false,
    "noIndex": false,
    "socialCards": [
        {
            "locale": "en-GB",
            "publisher": "https://www.facebook.com/mancity",
            "type": "FacebookCard",
            "card": "Article",
            "title": "",
            "description": "",
            "url": "",
            "image": "",
            "site": "Manchester City FC"
        },
        {
            "creator": "@mancity",
            "domain": "www.mancity.com",
            "type": "TwitterCard",
            "card": "summary_large_image",
            "title": "Search Results",
            "description": "",
            "url": "",
            "image": "",
            "site": "@mancity"
        }
    ],
    "canonicalPageUrl": ""
};